// A "tax filer" is a household member whose identity is on the tax return —
// the primary taxpayer (`person`) and, if married, the spouse (`partner`).
// Children and other dependents are NOT filers even though they appear on
// the return; they affect credits (CTC, dependent care) but not the filing
// status itself or joint standard-deduction qualifiers (blind, 65+).
export interface TaxFilerCandidate {
  kind: 'person' | 'partner' | 'child' | 'dependent'
}

export const isTaxFiler = (member: TaxFilerCandidate): boolean =>
  member.kind === 'person' || member.kind === 'partner'
